import { IWhiteLabel, WHITELABEL_NAME } from 'lib/api/whitelabel/getWhiteLabel';
import { THEME_NAME } from '../auth';
import { IUserData } from 'lib/api/users/getUser';
import { RESELLER_IDS } from 'lib/const/Resellers';

export const getThemeByWhiteLabel = (
  whitelabel: IWhiteLabel | undefined,
  user?: IUserData
) => {
  if (user?.resellerId?.toString() === RESELLER_IDS.CDK) {
    return THEME_NAME.CDK;
  }
  if (!whitelabel) {
    return THEME_NAME.BRANDING;
  }
  if (whitelabel.name === WHITELABEL_NAME.COVIDEO) {
    return THEME_NAME.BRANDING;
  }

  return improveWhiteLabelName(whitelabel.name);
};

export const improveWhiteLabelName = (name: WHITELABEL_NAME) => {
  switch (name) {
    case WHITELABEL_NAME.KENNECTED:
      return THEME_NAME.KENNECTED;
    case WHITELABEL_NAME.PRO_VIDEO_NOW:
      return THEME_NAME.PROVIDEO;
    case WHITELABEL_NAME.APP_2_VID:
      return THEME_NAME.APP_2_VID;
    case WHITELABEL_NAME.CDK:
      return THEME_NAME.CDK;
    default:
      return THEME_NAME.COVIDEO;
  }
};
